module.exports = __webpack_public_path__ + "static/media/connected-river-interreg-ns-horizontal.609f45df.png";